import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import FieldInput from "./fields/FieldInput";
import { ConstatGravity } from "../../types/constatGravities";

const schema = z.object({
  name: z.string().min(1, "Requis").max(50, "50 caractÃ¨res max"),
  code: z.string().min(1, "Requis").max(20, "20 caractÃ¨res max"),
  description: z.string().max(150, "150 caractÃ¨res max").optional(),
});

export type SchemaFormConstatGravity = z.infer<typeof schema>;

export const transformConstatGravityToFormValues = (
  constatGravity?: ConstatGravity,
): SchemaFormConstatGravity => {
  if (!constatGravity) return { name: "", code: "", description: "" };
  return {
    name: constatGravity.name,
    code: constatGravity.code,
    description: constatGravity.description ?? "",
  };
};

type Props = {
  onSubmit: SubmitHandler<SchemaFormConstatGravity>;
  defaultValues?: SchemaFormConstatGravity;
};

const FormConstatGravity: React.FC<Props> = ({ onSubmit, defaultValues }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SchemaFormConstatGravity>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <Form onFinish={handleSubmit(onSubmit)} id="form-constat-gravity">
      <FieldInput<SchemaFormConstatGravity>
        control={control}
        name="name"
        label="Nom"
        placeholder="Nom..."
        errorMessage={errors?.name?.message}
        isVertical
      />
      <FieldInput<SchemaFormConstatGravity>
        control={control}
        name="code"
        label="Code"
        placeholder="Code..."
        errorMessage={errors?.code?.message}
        isVertical
      />
      <FieldInput<SchemaFormConstatGravity>
        control={control}
        name="description"
        label="Description"
        placeholder="Description..."
        errorMessage={errors?.description?.message}
        isVertical
      />
    </Form>
  );
};

export default FormConstatGravity;
